import { gql } from '@apollo/client';

export default gql`
  query GetSignedUrl($input: GetSignedUrlInput) {
    getSignedUrl(input: $input)
  }
`;
